import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['tab', 'status', 'bemerkung']

  connect() {
    const ersterTab = this.tabTargets[0]
    if (ersterTab) this.select({ currentTarget: ersterTab })
  }

  select(event) {
    const tab = event.currentTarget
    const code = tab.dataset.code

    this.tabTargets.forEach(t => t.classList.toggle('tack-tab--active', t === tab))

    this.statusTargets.forEach(el => {
      el.classList.toggle('d-none', el.dataset.code !== code)
    })

    this.bemerkungTargets.forEach(el => {
      el.classList.toggle('d-none', el.dataset.code !== code)
    })
  }
}
